import React from "react";
import { SANS_2, SANS_3, UI_BODY_SM_DF } from "oolib";

const DateTimeDisplay = ({
  value,
  textComp = "UI_BODY_SM_DF",
  ...textCompProps
}) => {
  const TextComps = {
    SANS_3,
    SANS_2,
    UI_BODY_SM_DF,
  };

  const TextComp = TextComps[textComp];

  if (!value) return <TextComp {...textCompProps}>{" "}</TextComp>;

  const d = new Date(value);
  if (isNaN(d.getTime())) return <TextComp {...textCompProps}>{" "}</TextComp>;

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  let hours = d.getHours();
  const minutes = String(d.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  const formatted = `${day}/${month}/${year}, ${hours}:${minutes} ${ampm}`;

  return <TextComp {...textCompProps}>{formatted}</TextComp>;
};

export default DateTimeDisplay;
